import { REHYDRATE } from 'redux-persist';
import * as types from '../actions/types';
const initialState = {
    isFetching: false,
    isLoggingInBank: false,
    plaid_details: null,
    lastLinked: undefined,
    banks: [],
    installedBankApps: undefined,
    renewingConnection: undefined,
    linkingConnection: undefined,
    linkingBankId: undefined,
    importedAccounts: undefined,
    syncingAccounts: undefined,
};
const linkBank = (state = initialState, action) => {
    switch (action.type) {
        case REHYDRATE:
            if (action.payload?.linkBank)
                return {
                    ...initialState,
                    lastLinked: action.payload.linkBank.lastLinked,
                };
            return state;
        case types.LOGIN_BANK_REQUEST:
            return { ...state, isLoggingInBank: true };
        case types.PLAID_LINK_SUCCESS:
            return {
                ...state,
                plaid_details: action.payload?.params,
                linkingBankId: action.extra.isLoggedIn ? -1 : state.linkingBankId,
            };
        case types.LINK_SUCCESS: {
            const { connection, bankId, isLoggedIn } = action.extra;
            const { renewingConnection, linkingConnection } = state;
            const isRenewingInLinkFlow = linkingConnection &&
                connection &&
                linkingConnection.id === connection.id;
            const isRenewingInRenewFlow = connection &&
                renewingConnection &&
                renewingConnection.id === connection.id;
            const newRenewingConnection = isRenewingInRenewFlow
                ? renewingConnection
                : connection;
            if (!isLoggedIn) {
                return {
                    ...state,
                    plaid_details: action.payload?.params,
                };
            }
            return {
                ...state,
                plaid_details: action.payload?.params,
                renewingConnection: !isRenewingInLinkFlow && bankId === undefined
                    ? newRenewingConnection
                    : undefined,
                linkingBankId: isRenewingInLinkFlow ? linkingConnection.bankId : bankId,
                linkingConnection: isRenewingInLinkFlow ? linkingConnection : undefined,
            };
        }
        case types.LOGIN_BANK_SUCCESS:
            return { ...state, isLoggingInBank: false };
        case types.LOGIN_BANK_FAILURE:
            return { ...state, isLoggingInBank: false };
        case types.BANKS_REQUEST:
            return { ...state, isFetching: true };
        case types.BANKS_SUCCESS:
            return {
                ...state,
                banks: action.payload.banks,
                isFetching: false,
            };
        case types.SET_INSTALLED_BANK_APPS: {
            return {
                ...state,
                installedBankApps: action.banks,
            };
        }
        case types.BANKS_FAILURE:
            return {
                ...state,
                isFetching: false,
            };
        case types.CONNECTION_CHANGE_HANDLED: {
            if (action.payload.status) {
                return {
                    ...state,
                    lastLinked: action.payload.bankInfo,
                };
            }
            return state;
        }
        case types.LIST_PROVIDER_ACCOUNTS_SUCCESS: {
            const { renewingConnection, linkingBankId } = state;
            if (!renewingConnection && !linkingBankId)
                return state;
            const closedAccountsBeforeRenew = new Set();
            renewingConnection?.accounts.forEach((account) => {
                if (account.isClosed) {
                    closedAccountsBeforeRenew.add(account.id);
                }
            });
            const syncingRenewalsForConn = [];
            const importedAccounts = action.payload.accounts.reduce((acc, account) => {
                const wasClosed = account.id && closedAccountsBeforeRenew.has(account.id);
                syncingRenewalsForConn.push({
                    ...account,
                    id: account.id ?? -1,
                    isClosed: account.isDeleted || account.isClosed,
                    isRemoved: account.isDeleted || account.isRemoved,
                    isLoading: (account.isDeleted && !wasClosed) ||
                        (!account.isDeleted && wasClosed) ||
                        account.id == null,
                });
                if (account.isNew) {
                    acc.new.push(account);
                    return acc;
                }
                if (account.isDeleted) {
                    const accountFromConnection = renewingConnection?.accounts.find((a) => a.id === account.id);
                    if (accountFromConnection && !accountFromConnection?.isClosed) {
                        acc.missing.push(account);
                    }
                    return acc;
                }
                acc.existing.push(account);
                return acc;
            }, { new: [], existing: [], missing: [] });
            return {
                ...state,
                importedAccounts,
                syncingAccounts: {
                    ...state.syncingAccounts,
                    [renewingConnection?.id || action.extra.connectionId]: syncingRenewalsForConn.sort((a, b) => {
                        if (a.id === -1 && b.id === -1)
                            return 0;
                        if (a.id === -1)
                            return 1;
                        if (b.id === -1)
                            return -1;
                        return a.id - b.id;
                    }),
                },
            };
        }
        case types.CLEAR_SYNCING_ACCOUNTS: {
            if (!state.syncingAccounts)
                return state;
            const syncingAccounts = { ...state.syncingAccounts };
            delete syncingAccounts[action.payload.connectionId];
            return {
                ...state,
                syncingAccounts,
            };
        }
        case types.SET_LINKING_CONNECTION:
            return {
                ...state,
                linkingConnection: action.payload.connection,
            };
        case types.RESET_RENEWING_CONNECTION:
        case types.RESET_LINKING_CONNECTION:
            return {
                ...state,
                linkingConnection: undefined,
                importedAccounts: undefined,
                linkingBankId: undefined,
                renewingConnection: undefined,
            };
        case types.NEW_ACCOUNTS_MOVE_SPACE_SUCCESS:
            return {
                ...state,
                scheduledMoveSpace: action.payload.status === 'scheduled'
                    ? {
                        accountProviderIds: action.extra.accountProviderIds,
                        bankConnectionId: action.extra.bankConnectionId,
                    }
                    : undefined,
            };
        case types.RESET_ACCOUNTS_MOVE_SPACE:
            return {
                ...state,
                scheduledMoveSpace: undefined,
            };
        case types.LOGGED_OUT:
            return initialState;
        default:
            return state;
    }
};
export default linkBank;
